import React from 'react';

import { LinearGradient } from '@/components/linear-gradient/LinearGradient';
import type { LinearGradientProps } from '@/components/linear-gradient/types';
import { withOpacity } from '@/styles/styles';

import { ds } from '../lib/design.system';

type Props = {
    /** The surface colour the content dissolves into. Defaults to the card surface. */
    color?: string;
    /** Custom color stops — (color, 0–1 position) pairs for non-linear fades. */
    stops?: { color: string; position: number }[];
    /** Positioning + size (absolute offset, width) — varies per use, so the caller supplies it. */
    style?: LinearGradientProps['style'];
    width?: number;
};

/**
 * Horizontal "safety shadow" — a transparent→surface fade that dissolves clipped text/content into the
 * surface at its right edge. Shared by the payout, promo, and entry-card bottoms.
 */
export const SafetyShadow = ({ color = ds.colorValue.background.neutral.subtler, stops, style, width }: Props) => {
    const gradientColors = stops ? stops.map(s => s.color) : [withOpacity(color, 0), color];
    const gradientPositions = stops ? stops.map(s => s.position) : undefined;
    return (
        <LinearGradient
            colors={gradientColors}
            positions={gradientPositions}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            width={width}
            style={style}
        />
    );
};
